"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("g", {
    id: "*file"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M2.58579 1.25278C2.96086 0.877706 3.46957 0.666992 4 0.666992H8.66667C8.84348 0.666992 9.01305 0.73723 9.13807 0.862254L13.8047 5.52892C13.9298 5.65395 14 5.82351 14 6.00033V13.3337C14 13.8641 13.7893 14.3728 13.4142 14.7479C13.0391 15.1229 12.5304 15.3337 12 15.3337H4C3.46957 15.3337 2.96086 15.1229 2.58579 14.7479C2.21071 14.3728 2 13.8641 2 13.3337V2.66699C2 2.13656 2.21071 1.62785 2.58579 1.25278ZM4 2.00033C3.82319 2.00033 3.65362 2.07056 3.5286 2.19559C3.40357 2.32061 3.33333 2.49018 3.33333 2.66699V13.3337C3.33333 13.5105 3.40357 13.68 3.5286 13.8051C3.65362 13.9301 3.82319 14.0003 4 14.0003H12C12.1768 14.0003 12.3464 13.9301 12.4714 13.8051C12.5964 13.68 12.6667 13.5105 12.6667 13.3337V6.27647L8.39052 2.00033H4Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector (Stroke)_2",
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8.66667 0.666992C9.03486 0.666992 9.33333 0.965469 9.33333 1.33366V5.33366H13.3333C13.7015 5.33366 14 5.63214 14 6.00033C14 6.36852 13.7015 6.66699 13.3333 6.66699H8.66667C8.29848 6.66699 8 6.36852 8 6.00033V1.33366C8 0.965469 8.29848 0.666992 8.66667 0.666992Z",
    fill: fill
  })));
};

exports["default"] = _default;